import { fetchIsDemoProject } from './fetch-is-demo-project';

export const actions = {
	fetchIsDemoProject,
} as const;

export type StoreActions = typeof actions;
